import { defineEvent } from '../types/event';
export var CART_ADD_PCP = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Add_to_Cart_PCP'
        }
    ]
});
